import api from '../api';
import { string } from 'prop-types';
import Axios from 'axios';
import { getJwt } from '@app/helpers';

export interface DocumentacaoAcessoriaMensal {
  documentoMensalId: string;
  contratoId: string;
  ano: number;
  mes: string;
  documentosAcessorios: Array<DocumentoAcessorio>;
  documentoMensalStatus: string;
}
export interface DocumentoAcessorio {
  id: string;
  aplicabilidade: string;
  nomeArquivo?: string;
  localArquivo?: string;
  documentoAcessorioStatus: string;
  dataValidade: Date;
  justificativa: string;
  documento: string;
  codigoStatus:number;
}

export const getAllDocumentacaoAcessoriaMensalByContrato = (contratoId: any) =>
  api.get<DocumentacaoAcessoriaMensal[]>(`documentacaoacessoria/contrato/documentacaoMensal/${contratoId}`);

export const getAllDocumentosAcessorioByDocumentacaoMensal = (documentacaoMensalId: any) =>
  api.get<DocumentoAcessorio[]>(`documentacaoacessoria/documentacaoMensal/fornecedor/${documentacaoMensalId}`);

export const updateDocumentacaoAcessoriaFornecedor = (file: any, DocumentacaoAcessoria: DocumentoAcessorio): any => {
  const form = new FormData();
  Object.keys(DocumentacaoAcessoria).forEach(key => {
    form.append(key, DocumentacaoAcessoria[key]);
  });
  form.append('file', file);

  return api.put(`documentacaoacessoria/fornecedor`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteDocumentacaoAcessoria = (id: string) => api.delete(`documentacaoacessoria/${id}`);

export const updateDocumentoAcessorioAplicabilidade = (DocumentacaoAcessoria: DocumentacaoAcessoriaMensal) =>
  api.put(`documentacaoacessoria/contrato/${DocumentacaoAcessoria.contratoId}`, DocumentacaoAcessoria);

export const SendDocumentoAcessorio = (DocumentoAcessorioId: string): any =>
  api.put(`documentacaoacessoria/send/${DocumentoAcessorioId}`);

export const ApproveDocumentoAcessorio = (DocumentoAcessorioId: string): any =>
  api.put(`documentacaoacessoria/approve/${DocumentoAcessorioId}`);

export const ReproveDocumentoAcessorio = (DocumentoAcessorioId: string): any =>
  api.put(`documentacaoacessoria/reprove/${DocumentoAcessorioId}`);

export const RemoveFileDocumentoAcessorio = (DocumentoAcessorioId: string): any =>
  api.put(`documentacaoacessoria/removefile/${DocumentoAcessorioId}`);

export const download = (path: string, fileName: string) => {
  Axios.get(`/api/documentacaoacessoria/contrato/download?path=${path}&fileName=${fileName}`, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};
